import { render, staticRenderFns } from "./TradeAccountDetails.vue?vue&type=template&id=7aa2b2c2&"
import script from "./TradeAccountDetails.vue?vue&type=script&lang=js&"
export * from "./TradeAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./TradeAccountDetails.vue?vue&type=style&index=0&id=7aa2b2c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports